import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgTakeABreak = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 64 64"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="hsl(var(--system-icon-background-default))"
        d="M59.976 5.776c-23.96-8.65-46.853-3.604-55.547 0-8.021 23.667-3.342 45.442 0 53.371 23.783 8.79 46.78 3.662 55.547 0 7.288-22.036 3.037-44.762 0-53.37"
      />
      <path
        fill="hsl(var(--system-icon-white))"
        d="M32 50.333c10.125 0 18.333-8.208 18.333-18.333S42.125 13.667 32 13.667 13.667 21.875 13.667 32 21.875 50.333 32 50.333"
      />
      <path
        fill="hsl(var(--system-icon-foreground))"
        d="M48.958 32c0-9.366-7.592-16.958-16.958-16.958S15.042 22.634 15.042 32 22.634 48.958 32 48.958 48.958 41.366 48.958 32m2.75 0c0 10.885-8.823 19.708-19.708 19.708S12.292 42.885 12.292 32 21.115 12.292 32 12.292 51.708 21.116 51.708 32"
      />
      <path
        fill="hsl(var(--system-icon-foreground))"
        d="M37.958 32c0-1.767-.002-2.955-.121-3.84-.114-.846-.311-1.208-.55-1.447s-.6-.436-1.447-.55c-.885-.119-2.073-.121-3.84-.121s-2.955.002-3.84.121c-.846.114-1.208.311-1.447.55s-.436.6-.55 1.447c-.119.885-.121 2.073-.121 3.84s.002 2.955.121 3.84c.114.846.311 1.208.55 1.447s.6.436 1.447.55c.885.119 2.073.121 3.84.121s2.955-.002 3.84-.121c.846-.114 1.208-.311 1.447-.55s.436-.6.55-1.447c.119-.885.121-2.073.121-3.84m2.75 0c0 1.69.003 3.096-.146 4.207-.155 1.151-.496 2.19-1.33 3.024-.836.835-1.874 1.176-3.025 1.33-1.111.15-2.517.147-4.207.147s-3.096.003-4.207-.146c-1.151-.155-2.19-.496-3.024-1.33s-1.176-1.874-1.33-3.025c-.15-1.111-.147-2.517-.147-4.207s-.003-3.096.146-4.207c.155-1.15.496-2.19 1.33-3.024s1.874-1.176 3.025-1.33c1.111-.15 2.517-.147 4.207-.147s3.096-.003 4.207.147c1.15.154 2.19.495 3.024 1.33s1.176 1.873 1.33 3.024c.15 1.111.147 2.518.147 4.207"
      />
    </svg>
  );
};
export default SvgTakeABreak;
